<div class="callback-container">
    <div class="callback-card glass-panel">
        @if (loading) {
            <div class="loading-state">
                <div class="spinner"></div>
                <h2>Signing you in...</h2>
                <p class="muted-text">Completing authentication...</p>
            </div>
        }

        @if (error) {
            <div class="error-state">
                <div class="error-icon">⚠️</div>
                <h2>Authentication Failed</h2>
                <p class="error-message">{{ error }}</p>
                <a href="/login" class="btn btn-primary">Back to Login</a>
            </div>
        }
    </div>
</div>
